import React from "react";
import AdminHome from "../../components/MainPage/AdminHomePage/Home";

const AdminHomePage = () => {
	return (
		<>
			<AdminHome />
		</>
	);
};

export default AdminHomePage;
